import React from "react";
import { Table } from "antd";

class ComponentToPrint extends React.Component {
  render() {
    return <div style={{ padding: 30 }}>{this.props.content}</div>;
  }
}

export default ComponentToPrint;
